import { Backdrop, Box, Button, CircularProgress, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useState } from "react";
import CityService from "../../../services/cityService";
import { useTheme } from "@emotion/react";
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';

const DeleteCityModal = ({ open,
    handleClose,
    setPopupMsg,
    setPopupType,
    setShowPopup,
    city }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isDeleted = city && city.deletedAt === null;

    const [isLoading, setIsLoading] = useState(false);
    const [deleteError, setDeleteError] = useState({});

    const handleDelete = async () => {
        try {
            setIsLoading(true);
            const data = await CityService.deleteCity(city.id);
            if (data.status === 200) {
                setPopupMsg(data.data.message);
                setPopupType(isDeleted ? 'delete' : 'success');
                setShowPopup(true);
                handleClose({ isReaload: true });
            }

        } catch (error) {
            setPopupMsg(error.response.data.error);
            setPopupType('error');
            console.error("An unexpected error occurred:", error);
            setDeleteError({ general: error.response.data.error });
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '40%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '80%' : '40%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        {/* title */}
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {isDeleted ? t('deleteCity') : t('retrieveCity')}
                        </Typography>
                        <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                    </Box>

                    {/* info text */}
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {isDeleted ? t('deleteCitySureMsg') : t('retrieveCitySureMsg')} <span style={{ fontWeight: 'bold' }}>{city && city.name}</span>
                    </Typography>


                    {deleteError.general && (
                        <Typography align="center" color="error" variant="body2" sx={{ mt: 2 }}>
                            {deleteError.general}
                        </Typography>
                    )}

                    <Box sx={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        mt: deleteError.general ? 2 : 4
                    }}>
                        {/* cancel */}
                        <Button
                            variant="outlined"
                            color="primary"
                            sx={{ textTransform: 'none', width: 140, height: 40 }}
                            onClick={handleClose}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <p>{t('cancel')}</p>
                                <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                            </Box>
                        </Button>

                        <Box width={20}></Box>

                        {/* delete */}
                        <Button
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                width: 140,
                                height: 40,
                                backgroundColor: isDeleted ? theme.palette.red.bg : theme.palette.green.bg,
                            }}
                            onClick={handleDelete}

                        >
                            {isLoading ? <CircularProgress color="secondary" size={28} /> :
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <p>{isDeleted ? t('delete') : t('retrieve')}</p>
                                    {isDeleted ?
                                        <DeleteOutlineOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                        :
                                        <ReplayOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />}
                                </Box>
                            }
                        </Button>

                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}

export default DeleteCityModal;
